import React from "react";
import { Link } from "react-router-dom";
import useAuth from "../../../../hooks/useAuth";
import { PlayCircleFilled } from "@ant-design/icons";

export default function Back() {
  const {
    ciudadano: { ciudadano },
  } = useAuth();

  return (
    <Link to={ciudadano && ciudadano.tipoUsuario === 1 ? "/ciudadano/inicio"
        : ciudadano && ciudadano.tipoUsuario === 2 ? "/organizacion/inicio" : "/"} className="back">
      <PlayCircleFilled rotate="180"/> Regresar
    </Link>
  );
}
